export interface AdyenBillingAddress {
  city: string;
  country: string;
  houseNumberOrName: string;
  postalCode: string;
  street: string;
}

export interface MelissaAddress {
  address: string;
  zipCode: string;
}

export interface AdyenAPMAdditionalInputs {
  shopperEmail: string;
  shopperName: string;
  billingAddress?: MelissaAddress;
  telephoneNumber?: string;
  email: string;
}

export const ADYEN_APM_FIELDS = {
  SHOPPER_EMAIL: 'shopperEmail',
  SHOPPER_NAME: 'shopperName',
  BILLING_ADDRESS: 'billingAddress',
  TELEPHONE_NUMBER: 'telephoneNumber',
  EMAIL: 'email',
} as const;

export interface DynamicFieldsAdyen {
  apm_key: string;
  defaultValue?: any;
  isRequired: boolean;
  validation?: string;
}
